<template>
<div>
  <div class="container">
    <div class="row">
        <div v-if="isLogin" class="offset-3 col-md-6  msg-area">
        <header>
          <h1>Group Chat</h1>
          <p class="sm">Welcome, {{this.username }} </p>

        </header>
        <div  class="msg">
          <p :class="this.username == message.name ? 'mssgsMe' : 'mssgs'  " v-for="(message,index) in messages" :key="index">{{ message.message }} <br>  <span> {{  message.name == this.username ? '' :  message.name + ' - '  }}  {{ message.time }} </span>  </p> 
        </div>

        <div class="sendMsg">
            <form @submit.prevent="sendFunc">
                  <div class="form-group d-flex">
    
    <input type="text" class="form-control" placeholder="Enter message.." v-model="msgInput">
    <button class="btn">Send </button>
    
  </div>

              

            </form>
        </div>

  
  
  </div>

<div class="offset-3 col-md-6 login" v-else>

  <form @submit.prevent="joinFunc">
 <div class="form-group d-flex">
    
    <input type="text" class="form-control" placeholder="Enter username.." v-model="username">
    <button class="btn">Join to Group </button>
    
    </div>

  </form>

</div>

  </div>
  </div>
</div>
</template>

<script>

import firebase from "./firebase";
import 'firebase/firestore';

export default {
 
  data() {
    return {
     db : firebase.firestore(),
    isLogin: false,
    username: '',
      messages : [],
      msgInput: '',
      
      
    }
  },
  methods: {
    joinFunc() {
      
      this.isLogin = true;
    },
    sendFunc() {
        let date = new Date();
        let hour = date.getHours();
        let minute = date.getMinutes();
        let nowTime = hour + ':' + minute;
     this.db.collection("messages")
          .add({ message: this.msgInput, name: this.username, time: nowTime, date: date })
          .then(() => {  var messageBody = document.querySelector('.msg');
      messageBody.scrollTop = messageBody.scrollHeight ;
      console.log(messageBody.scrollTop); })
          .catch((error) => {
            console.error("Error writing document: ", error);
          });
      this.msgInput = "";

    },
   
    
  },
  mounted: function() {

    
    this.db.collection("messages").orderBy("date", "asc")
        .get()
        .then((querySnapshot) => {
         
          querySnapshot.forEach((doc) => {
           this.messages.push({
              name: doc.data().name,
              msg: doc.data().message,
              time: doc.data().time
            });

            
           
          });

         
        
          
         
        })

      
this.db.collection("messages").orderBy("date", "asc").onSnapshot(snapshot => {
  let changes = snapshot.docChanges();
  changes.forEach(change => {
   this.messages.push(change.doc.data());
   
  })
     
})


    }
  
 
}

</script>

<style>
* {
  padding: 0;
  margin: 0;
}

body{
  font-family: 'Roboto', sans-serif;
}
.msg-area {
  
}




header {
background: rgb(36,52,247);
background: linear-gradient(180deg, rgba(36,52,247,1) 18%, rgba(85,95,230,1) 41%, rgba(115,119,211,1) 100%);
  color: #fff;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 4px;
  padding: 0.2rem 1rem;
}

header h1  {
  font-size: 1.3rem;
  padding:0;
  margin:0;
}

.msg {
  padding: 0.4rem 1rem;
  height:80vh;
  background:#fff;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 4px;
  border-bottom: 1px solid #d0d0d0;
  overflow: scroll;
  overflow-x: hidden;
  
}

.msg::-webkit-scrollbar {
  width: 3px;
}

.msg::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.msg::-webkit-scrollbar-thumb {
  background: rgba(36,52,247,0.7);
}

.msg::-webkit-scrollbar-thumb:hover {
  background: #555;
}


header p {
  font-size: 0.8rem;
  padding:0;
  margin:0;
  font-weight: 300;
  font-style: italic;
}

.sendMsg {

}

form .form-control:focus {
  outline: 0 !important;
  box-shadow: inset 0 0 0 #ddd;
   border:none;
   border-bottom: 1px solid #e4e3e3;
}

form .form-control{
  padding: 0.4rem 0.8rem;
  border:none;
  border-bottom: 1px solid #e4e3e3;
}

.btn {
  background: rgb(36,52,247);
  color: #fff;
  border-radius: 0;
}

.btn:hover {
  background: rgba(36,52,247,0.9);
  color: #fff;
}

.btn:focus {
  outline: 0 !important;
  box-shadow: inset 0 0 0 #ddd;

}

.mssgsMe {
  background: rgb(42, 42, 42);
background: linear-gradient(90deg, rgb(78, 78, 78) 18%, rgb(73, 73, 73) 41%, rgb(95, 95, 95) 100%);
padding: 1rem;
color: #fff;
border-radius: 1rem;

width: 70%;
padding-bottom: 2rem;
position: relative;
left: 30%;

}

.mssgs {
  background: rgb(36,52,247);
background: linear-gradient(90deg, rgba(36,52,247,1) 18%, rgba(85,95,230,1) 41%, rgba(115,119,211,1) 100%);
padding: 1rem;
color: #fff;
border-radius: 1rem;
width: 70%;
padding-bottom: 2rem;
position: relative;

}

.mssgs span {
  background-color: #fff;
  color: rgb(36,52,247);
  
  padding: 0.1rem 0.6rem;
  position: absolute;
  right: 0;
  margin-top: 0.5rem;
  padding-top: 0.3rem;
  border-radius: 0.6rem;
  font-size: 0.8rem;
  font-weight: 400;
  font-style: italic;
 
}

.mssgsMe span {
  background-color: #fff;
  color: rgb(42, 42, 42);
  
  padding: 0.1rem 0.6rem;
  position: absolute;
  right: 0;
  margin-top: 0.5rem;
  padding-top: 0.3rem;
  border-radius: 0.6rem;
  font-size: 0.8rem;
  font-weight: 400;
  font-style: italic;
 
}

.login {
  position: absolute;
  width: 400px;
  top: 50%;
  transform: translateY(-50%);
  
}

.login .btn {
  width: 200px;
}





</style>
